import React, { Component } from "react";

// JS File
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// CSS File
import "./App.css";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "lightgallery.js/dist/css/lightgallery.css";
import "./Content/Statics/Common/video-react.css";

// HomePage
import HomePage from "./Content/Layouts/HomePage/HomePage.js";

// AboutUs
import Introduction from "./Content/Layouts/AboutUs/Introduction.js";
import OurCompanies from "./Content/Layouts/AboutUs/OurCompanies.js";
import ManagerMessage from "./Content/Layouts/AboutUs/ManagerMessage.js";
import HumanResource from "./Content/Layouts/AboutUs/HumanResource.js";
import MultiMediaImg          from './Content/Layouts/AboutUs/MultiMediaImg.js';
import MultimediaVideo        from './Content/Layouts/AboutUs/MultimediaVideo.js';
import MultimediaNews         from './Content/Layouts/AboutUs/MultiMediaNews.js';
import MultimediaAzar from "./Content/Layouts/AboutUs/MultiMediaAzar.js";
import MultiMediaNozrooz from "./Content/Layouts/AboutUs/MultiMediaNozrooz.js";


import Rewards from "./Content/Layouts/AboutUs/Rewards.js";

// OurServices
import OurServices from "./Content/Layouts/OurServices/OurServices.js";

// InsuranceKnowledge
import Approvals from "./Content/Layouts/InsuranceKnowledge/Approvals.js";
import ApprovalsSecPage from "./Content/Layouts/InsuranceKnowledge/ApprovalsSecPage.js";
import Laws from "./Content/Layouts/InsuranceKnowledge/Laws.js";
import GeneralOne from "./Content/Layouts/InsuranceKnowledge/GeneralOne.js";
import GeneralTwo from "./Content/Layouts/InsuranceKnowledge/GeneralTwo.js";
import SpecificOne from "./Content/Layouts/InsuranceKnowledge/SpecificOne.js";
import SpecificTwo from "./Content/Layouts/InsuranceKnowledge/SpecificTwo.js";
import SpecificThree from "./Content/Layouts/InsuranceKnowledge/SpecificThree.js";
import SpecificFour from "./Content/Layouts/InsuranceKnowledge/SpecificFour.js";
import SpecificFive from "./Content/Layouts/InsuranceKnowledge/SpecificFive.js";
import BooksArticles from "./Content/Layouts/InsuranceKnowledge/BooksArticles.js";
import BooksSecPage from "./Content/Layouts/InsuranceKnowledge/BooksSecPage.js";
import BooksAll     from "./Content/Layouts/InsuranceKnowledge/BooksAll.js";
import ArticlesSecPage from "./Content/Layouts/InsuranceKnowledge/ArticlesSecPage.js";
import Ecosystem    from "./Content/Layouts/InsuranceKnowledge/Ecosystem.js";

// Responsibility
import Responsibility from "./Content/Layouts/Responsibility/Responsibility.js";
import ResponsibilitySecPage from "./Content/Layouts/Responsibility/ResponsibilitySecPage.js";

// ContactUs
import ContactUs from "./Content/Layouts/ContactUs/ContactUs.js";
import Branches from "./Content/Layouts/ContactUs/Branches.js";
import Festival from "./Content/Layouts/ContactUs/Festival.js";
import WorkWithUs from "./Content/Layouts/ContactUs/WorkWithUs.js";

// Download App
import ArzyabApp from "./Content/Layouts/DownloadApps/ArzyabApp";
import SanaapApp from "./Content/Layouts/DownloadApps/SanaapApp";
import ArzyabAppAmval from "./Content/Layouts/DownloadApps/ArzyabAppAmval";


class App extends Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={HomePage} />

            <Route path="/aboutus" component={Introduction} />
            <Route path="/ourcompanies" component={OurCompanies} />
            <Route path="/managermessage" component={ManagerMessage} />
            <Route path="/humanresource" component={HumanResource} />
            <Route path="/imagegallery" component={MultiMediaImg} />
            <Route path="/videogallery" component={MultimediaVideo} />
            <Route path="/news" component={MultimediaNews} />
            <Route path="/13azar" component={MultimediaAzar} />
            <Route path="/norooz" component={MultiMediaNozrooz} />
            <Route path="/rewards" component={Rewards} />

            <Route path="/ourservices/:tab" component={OurServices} />

            <Route path="/approvals" component={Approvals} />
            <Route path="/approvalsinside/:id" component={ApprovalsSecPage} />
            <Route path="/laws" component={Laws} />
            <Route path="/generalone" component={GeneralOne} />
            <Route path="/generaltwo" component={GeneralTwo} />
            <Route path="/specificone" component={SpecificOne} />
            <Route path="/specifictwo" component={SpecificTwo} />
            <Route path="/specificthree" component={SpecificThree} />
            <Route path="/specificfour" component={SpecificFour} />
            <Route path="/specificfive" component={SpecificFive} />
            <Route path="/booksarticles" component={BooksArticles} />
            <Route path="/booksAll" component={BooksAll} />
            <Route path="/ecosystem" component={Ecosystem} />
            <Route
              path="/booksinside/:id"
              render={(props) => (
                <BooksSecPage key={props.match.params.id} {...props} />
              )}
            />
            <Route
              path="/articlesinside/:id"
              render={(props) => (
                <ArticlesSecPage key={props.match.params.id} {...props} />
              )}
            />

            <Route path="/responsibility" component={Responsibility} />
            <Route
              path="/responsibilityinside/:id"
              component={ResponsibilitySecPage}
            />

            <Route path="/contactus" component={ContactUs} />
            <Route path="/branches" component={Branches} />
            <Route path="/festival" component={Festival} />
            <Route path="/workwithus" component={WorkWithUs} />

            <Route path="/download-app-arzyab" component={ArzyabApp} />
            <Route path="/download-app-arzyab-amval" component={ArzyabAppAmval} />
            <Route path="/download-app-sanaap" component={SanaapApp} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
